import {
  React,
  Component,
  axios,
  routes,
  helpers,
} from 'imports/CommonImports';

import {
  PrimaryButton,
  PrimaryColor1,
} from 'imports/DesignImports';

import {
  Paper,
  TextField,
  SelectField,
  MenuItem,
} from 'material-ui';

const styles = {
  paper: {
    padding: '1em'
  },
  header: {
    marginLeft: '1em'
  },
  fieldsContainer: {
    display: 'flex',
    paddingRight: '15px'
  },
  fieldContainer: {
    minWidth: '25%',
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    margin: '0px 15px',
    fontWeight: '300',
  },
  field:{
    fontFamily: 'Lato',
    fontStyle: 'italic',
    paddingLeft: '10px',
    paddingRight: '0',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '1em',
  },
  selectField: {
    marginLeft: '1em',
    fontWeight: '300',
  },
}
export default class CompanyCreator extends Component {
  constructor(props){
    super(props);
    this.state = {
      data: {
        companyName: '',
        industryName: props.industries[0].name || 'Default',
        otherIndustry: '',
        ceoFirstName: '',
        ceoLastName: '',
        ceoEmail: '',
        cioFirstName: '',
        cioLastName: '',
        cioEmail: '',
        cfoFirstName: '',
        cfoLastName: '',
        cfoEmail: '',
        consultantId: props.staff[0].id || 0,
      },
      errors: {
        ceoEmail: '',
        cioEmail: '',
        cfoEmail: '',
      },
      otherSelected: false,
    }
  }

  render() {
    return (
      <div>
        <Paper zDepth={1} style={styles.paper}>
          <h3 style={styles.header}>Datos empresa</h3>
            <div style={styles.fieldsContainer}>
              <div style={styles.fieldContainer}>
                <div style={styles.label}>Nombre</div>
                <TextField
                inputStyle={styles.field}
                name="companyName"
                value={this.state.data.companyName}
                onChange={this.handleChange}
                />
              </div>
              <div style={styles.fieldContainer}>
                <div style={styles.label}>Industria</div>
                <SelectField
                  style={styles.selectField}
                  value={this.state.data.industryName}
                  onChange={this.handleIndustrySelectChange}
                  >
                  {this.props.industries.map((industry) => {
                    return(<MenuItem key={industry.id} value={industry.name} primaryText={industry.name} styles={styles.menuItem}/>)
                  })}
                  <MenuItem value='Otra' primaryText='Otra' styles={styles.menuItem}/>
                </SelectField>
              </div>
              {this.state.data.industryName === 'Otra' &&
                <div style={styles.fieldContainer}>
                  <TextField
                    hintText='Escribe aquí'
                    inputStyle={styles.field}
                    name="otherIndustry"
                    value={this.state.data.otherIndustry}
                    onChange={this.handleChange}
                  />
                </div>
              }
            </div>
          <h3 style={styles.header}>Gerente General</h3>
            <div style={styles.fieldsContainer}>
              <div style={styles.fieldContainer}>
                <div style={styles.label}>Nombre</div>
                <TextField
                inputStyle={styles.field}
                name="ceoFirstName"
                value={this.state.data.ceoFirstName}
                onChange={this.handleChange}
                />
                </div>
              <div style={styles.fieldContainer}>
                <div style={styles.label}>Apellidos</div>
                <TextField
                inputStyle={styles.field}
                name="ceoLastName"
                value={this.state.data.ceoLastName}
                onChange={this.handleChange}
                />
              </div>
              <div style={styles.fieldContainer}>
                <div style={styles.label}>Mail</div>
                <TextField
                  errorText={this.state.errors.ceoEmail}
                inputStyle={styles.field}
                name="ceoEmail"
                value={this.state.data.ceoEmail}
                onChange={this.handleChange}
                />
              </div>
          </div>
          <h3 style={styles.header}>Gerente de Innovación</h3>
            <div style={styles.fieldsContainer}>
              <div style={styles.fieldContainer}>
                <div style={styles.label}>Nombre</div>
                <TextField
                inputStyle={styles.field}
                name="cioFirstName"
                value={this.state.data.cioFirstName}
                onChange={this.handleChange}
                />
                </div>
              <div style={styles.fieldContainer}>
                <div style={styles.label}>Apellidos</div>
                <TextField
                inputStyle={styles.field}
                name="cioLastName"
                value={this.state.data.cioLastName}
                onChange={this.handleChange}
                />
              </div>
              <div style={styles.fieldContainer}>
                <div style={styles.label}>Mail</div>
                <TextField
                  errorText={this.state.errors.cioEmail}
                inputStyle={styles.field}
                name="cioEmail"
                value={this.state.data.cioEmail}
                onChange={this.handleChange}
                />
              </div>
          </div>
          <h3 style={styles.header}>Gerente de finanzas</h3>
            <div style={styles.fieldsContainer}>
              <div style={styles.fieldContainer}>
                <div style={styles.label}>Nombre</div>
                <TextField
                inputStyle={styles.field}
                name="cfoFirstName"
                value={this.state.data.cfoFirstName}
                onChange={this.handleChange}
                />
                </div>
              <div style={styles.fieldContainer}>
                <div style={styles.label}>Apellidos</div>
                <TextField
                inputStyle={styles.field}
                name="cfoLastName"
                value={this.state.data.cfoLastName}
                onChange={this.handleChange}
                />
              </div>
              <div style={styles.fieldContainer}>
                <div style={styles.label}>Mail</div>
                <TextField
                  errorText={this.state.errors.cfoEmail}
                inputStyle={styles.field}
                name="cfoEmail"
                value={this.state.data.cfoEmail}
                onChange={this.handleChange}
                />
              </div>
          </div>
          <h3 style={styles.header}>Consultor INNSPIRAL asignado</h3>
          <div style={styles.fieldsContainer}>
            <SelectField
              style={styles.selectField}
              value={this.state.data.consultantId}
              onChange={this.handleConsultantSelectChange}
              >
              {this.props.staff.map((employee) => {
                return(<MenuItem key={employee.id} value={employee.id} primaryText={employee.first_name + ' ' + employee.last_name} styles={styles.menuItem}/>)
              })}
            </SelectField>
          </div>
        </Paper>
        <div style={styles.buttonContainer}>
          <PrimaryButton label='Enviar Datos' onClick={this.createCompany} />
        </div>
      </div>
    );
  }

  handleChange = (event) => {
    var key = event.target.name;
    var value = event.target.value;
    if(key.includes('Email'))
      !helpers.validEmail(value) ? this.setState({ errors: {...this.state.errors, [key]: 'Debes ingresar un email válido'}}) : this.setState({ errors: {...this.state.errors, [key]: ''}})
    this.setState({ data: { ...this.state.data, [key]: value} });
  }

  handleConsultantSelectChange = (event, index, value) => {
    this.setState({ data: {...this.state.data, consultantId: value} });
  }

  handleIndustrySelectChange = (event, index, value) => {
    if(value !== 'Otra'){
      this.setState({
        otherSelected: false,
      });
    }
    else {
      this.setState({
        otherSelected: true,
      });
    }
    this.setState({data: {...this.state.data, industryName: value} })
  }

  errors = () => {
    for (var key in this.state.errors) {
       if (this.state.errors[key] !== '') {
         return true;
       }
    }
    if(this.state.data.otherIndustry === '' && this.state.otherSelected){
      return true;
    }
    return false;
  }

  createCompany = () => {
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.props.cookies.get('token')}
    });

    if(this.errors()){
      this.props.raiseAlertOneButton('¡Error!', 'Todos los campos deben ser llenados apropiadamente')
      return;
    }

    for (var key in this.state.data) {
       if (this.state.data.hasOwnProperty(key) && ((this.state.data[key] === '' && key !== 'otherIndustry') || this.state.data[key] === 0)) {
         this.props.raiseAlertOneButton('¡Error!', 'Todos los campos deben ser llenados apropiadamente')
         return;
       }
    }

    var data = {
      ceo: {
        firstName: this.state.data.ceoFirstName,
        lastName: this.state.data.ceoLastName,
        email: this.state.data.ceoEmail,
      },
      cio: {
        firstName: this.state.data.cioFirstName,
        lastName: this.state.data.cioLastName,
        email: this.state.data.cioEmail,
      },
      cfo: {
        firstName: this.state.data.cfoFirstName,
        lastName: this.state.data.cfoLastName,
        email: this.state.data.cfoEmail,
      },
      companyName: this.state.data.companyName,
      consultantId: this.state.data.consultantId,
      industryName: this.state.otherSelected ? this.state.data.otherIndustry : this.state.data.industryName,
    }

    this.props.raiseLoading();
    connection.post(routes.createCompany, data)
    .then((response) => {
      this.setState({
        companyName: '',
        industryName: this.props.industries[0].name || 'Default',
        otherIndustry: '',
        ceoFirstName: '',
        ceoLastName: '',
        ceoEmail: '',
        cioFirstName: '',
        cioLastName: '',
        cioEmail: '',
        cfoFirstName: '',
        cfoLastName: '',
        cfoEmail: '',
        consultantId: this.props.staff[0].id || 0,
      })
      this.props.raiseAlertOneButton('¡Éxito!', 'La nueva empresa se ha creado sin problemas')
    })
    .catch((err) => {
      this.props.raiseAlertOneButton('¡Error!', 'Hubo un problema al crear la empresa, intenta nuevamente')
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/administration/CreateCompany.js